import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import { renderKBMorePhotoUpload, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { showApiError } from 'utils/feedback';
import {
KBButton,
KBFormError,
KBForm,
KBMoreImageCropperInput } from
'components';
import config from 'app/config';
import { api } from 'app/services';
import * as selectors from 'app/selectors';
import _ from 'lodash';
import { DAY_TIME_HOUR } from 'app/constants';

const getLocationGroupUpdateParams = group => {
  const bpsitePcImage = group.bpsite_pc_image || [];
  return {
    id: group.id,
    name: group.name,
    location_ids: (group.locations || []).map(item => item.id),
    description: group.description,
    province_id: group.province_id || group.city && group.city.province_id,
    city_id: group.city_id || group.city && group.city.id,
    lg_code: group.lg_code,
    person_code: group.person_code,
    bridge_enabled: group.bridge_enabled,
    traffic: group.traffic,
    bridgego_visible: group.bridgego_visible,
    bpsite_visible: group.bpsite_visible,
    contact_email: group.contact_email,
    contact_phone: group.contact_phone,
    image: group.image,
    longitude: group.longitude,
    latitude: group.latitude,
    size: group.size,
    physical_address: group.physical_address,
    trading_area: group.trading_area,
    membership_card_code: group.membership_card_code,
    feature_tags: group.feature_tags,
    logo: group.logo,
    bpsite_pc_image: Array.isArray(bpsitePcImage) ? bpsitePcImage : [bpsitePcImage]
  };
};

let GroupSetStationImageForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.updateDeskImage = this.updateDeskImage.bind(this);this.UploadFailureCallBack = this.UploadFailureCallBack.bind(this);this.removeFile = this.removeFile.bind(this);}getInitialState()
  {
    const {
      fields: { desk_image } } =
    this.props;
    return {
      fileList: desk_image.initialValue || [],
      group: this.props.group || {} };

  }componentDidMount()

  {
    const {
      fields: { desk_image },
      loc_id } =
    this.props;
    api.getGroupsInfo(loc_id).then(json => {
      const groups = _.get(json, 'json.entities.groups', {})[loc_id];
      const fileList = _.get(groups, 'desk_image', []);
      this.setState({ fileList, group: groups || {} });
      desk_image.onChange(fileList);
    });
  }updateDeskImage(

  model) {
    const { updateLocation, group } = this.props;
    const groupInfo = this.state.group && this.state.group.id ? this.state.group : group;
    updateLocation && updateLocation({
      ...getLocationGroupUpdateParams(groupInfo),
      desk_image: model.desk_image || []
    });
  }UploadFailureCallBack(

  msg) {
    if (msg) {
      showApiError('上传失败', msg);
    }
  }removeFile(

  index) {
    const {
      fields: { desk_image } } =
    this.props;
    const { fileList } = this.state;
    let newFileList = [...fileList];
    newFileList.splice(index, 1);
    desk_image.onChange(newFileList);
    this.setState({ fileList: newFileList });
  }render()

  {
    const {
      fields: { desk_image },
      handleSubmit,
      submitting,
      loc_id } =
    this.props;
    const { fileList } = this.state;
    return (
      <KBForm
      type="reduxForm"
      onSubmit={handleSubmit(this.updateDeskImage)}>

        <fieldset className="fieldset" style={{ marginTop: '30px' }}>
          <legend>工位图片</legend>
          <div>
            <KBMoreImageCropperInput
            title={false}
            aspect={1125 / 750}
            accept=".png,.jpg,.jpeg"
            className="kb-form-group kb-form-c18 kb-form-alone"
            field={desk_image}
            type="groups"
            prefix={`groupsStation/${loc_id}/`}
            width={225}
            height={150}
            imageSize={1024}
            failureCallBack={this.UploadFailureCallBack}
            callback={v => this.setState({ fileList: v })}
            isPublic>

              <div className="upload-portrait">
                <div className="d-iblock" style={{ verticalAlign: 'middle' }}>
                  <button className="bordered-btn m-none" type="button">
                    {fileList && fileList.length ? '继续上传图片' : '上传图片'}
                  </button>
                  <p
                  className="color-nine"
                  style={{ paddingTop: 20, fontSize: 12 }}>

                    图片格式为png, jpeg或jpg,文件大小不大于10M
                  </p>
                </div>
              </div>
            </KBMoreImageCropperInput>
            <div>
              {fileList ?
              <ul className="kb-more-file" style={{ margin: 0 }}>
                  {fileList.map((file, index) => {
                  return (
                    <li key={index} style={{ cursor: 'pointer' }}>
                        <img
                      src={file}
                      alt="loading"
                      style={{
                        width: '225px',
                        height: '150px',
                        marginBottom: 10 }} />



                        <div className="delete">
                          <i
                        className="iconfont icon-close"
                        onClick={this.removeFile.bind(null, index)} />

                        </div>
                      </li>);

                })}
                </ul> :

              ''}

            </div>
            {/* <Field name="desk_image" component={renderKBMorePhotoUpload}
               defaultImages={defaultImages}
               uploadedText="上传图片"
               photoShow={true}
               sort={true}
               className="kb-form-group kb-form-alone"

               img_width={232}
               img_height={134}
               hint="图片格式为png或jpg,尺寸大小不小于200x150,文件大小不大于1M"
               text="上传图片"
               imgStyle={{ width: '232px', height: '134px', marginBottom: 10 }}
               prefix={`${config.uploadDir}groups/${loc_id}`}
              /> */}
          </div>
        </fieldset>
        <div className="kb-row border-bottom" style={{ paddingBottom: 30 }}>
          <KBButton
          className="certain-btn"
          type="submit"
          submitting={submitting}>

            确认保存
          </KBButton>
        </div>
      </KBForm>);

  }};


function mapStateToProps(state, props) {
  const { group, loc_id } = props;
  const defaultImages = group.desk_image;
  return {
    loc_id,
    initialValues: {
      desk_image: defaultImages } };


}

const validate = values => {
  const errors = {};

  return errors;
};

const formConfig = {
  form: 'GroupSetStationImageForm',
  validate: validate,
  touchOnBlur: false };


const LEGACY_FORM_FIELDS = ['desk_image'];

GroupSetStationImageForm = connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('GroupSetStationImageForm', LEGACY_FORM_FIELDS)(GroupSetStationImageForm)));

export default GroupSetStationImageForm;
